
export default {
  props: {
    slice: {
      type: Object,
      required: true,
    },
  },
  methods: {
    stripName(name) {
      return name.replace('2@x', '')
    },
  },
}
